module.exports = __webpack_public_path__ + "static/img/menageService2.dd4d1b84.png";